import AryllaSpinner from "./AryllaSpinner";

export default AryllaSpinner;
